/**
 * description: 交通费用抵扣登记
 * author: bql
 * 2023/6/8 16:35
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class TrafficRegisterApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'traffic-register'
    }

}

 